
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 62 62"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(2 2)","fill":"none","fill-rule":"evenodd","opacity":".75"}},[_c('circle',{attrs:{"stroke":"var(--vote-color, #fff)","stroke-width":"3","cx":"29","cy":"29","r":"29"}}),_c('circle',{attrs:{"fill":"var(--vote-color, #fff)","cx":"18.125","cy":"22.958","r":"3.625"}}),_c('circle',{attrs:{"fill":"var(--vote-color, #fff)","cx":"39.875","cy":"22.958","r":"3.625"}}),_c('path',{attrs:{"d":"M23.969 42.222c.416-.25.184-.328.317-.363l-.317-.663c-.417.429-1.615 1.445-1.615 2.304 0 1.001.812 1.813 1.813 1.813.942 0 1.19-.206 2.22-1.277.966-1.004 1.03-1.069 1.495-1.47.941-.812 1.897-1.37 2.957-1.654 2.162-.58 4.64-.58 7.447.022a1.813 1.813 0 00.76-3.545c-3.342-.717-6.397-.717-9.148.022-1.643.441-3.06 1.268-4.385 2.412-.587.506-.48.268-1.544 1.373-.19.198.07.845 0 .905v.12z","fill":"var(--vote-color, #fff)","fill-rule":"nonzero"}})])])
          )
        }
      }
    